import queryString from 'query-string';
import { fromJS } from 'immutable';
import { pureFilter } from '../../utils/urls';
import { START, SUCCESS, ERROR, FORM_SHOW, FORM_HIDE, VIEW_MODE } from '../../consts';
import {
  FILTER_RESET,
  FILTER_UPDATE,
  ANNOUNCEMENT_LOAD,
  SEARCH_FILTER,
  SUBSCRIPTION,
  ANNOUNCEMENT_COUNT_LOAD,
  AGENCIES_LOAD,
  AUTOCOMPLETE_UPDATE,
} from './actionTypes';

import api from '../../apiSingleton';

import {
  gtagPushEventNewPage,
  getCianDealType,
  getCianObjectType,
  getExtraCategory
} from '../../utils/googleAnalytics';
import GtagBuilder from '../../classes/builder/gtagEventBuilder';

export function fetchAnnouncement () {
  return (dispatch, getState) => {
    const state = getState();
    const section = state.get('section');
    const dealType = section.get('dealType');
    const realtyType = section.get('realtyType');

    const pure = pureFilter(state.getIn(['search', 'filter']));
    const filter = pure
      .set('regionId', pure.get('regionId', null) || state.getIn(['domain', 'regionId'], 55))
      .set('localityId', pure.get('localityId', null) || state.getIn(['domain', 'localityId'], null))
      .set('token', state.getIn(['user', 'token'], ''))
      .toJS();

    return dispatch(loadAnnouncement(dealType, realtyType, filter));
  };
}

export function loadCountAnnouncement (dealType, realtyType, filter) {
  return dispatch => {
    dispatch({
      type: ANNOUNCEMENT_COUNT_LOAD + START
    });

    return api.announcement.fetchCountAnnouncement(dealType, realtyType, filter)
        .then((data) => dispatch({
          type: ANNOUNCEMENT_COUNT_LOAD + SUCCESS,
          count: Number(data.count) || 0
        }))
        .catch((err) => dispatch({
          type: ANNOUNCEMENT_COUNT_LOAD + ERROR,
          payload: err.message
        }));
  };
}

export function loadAnnouncement (dealType, realtyType, filter) {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.get('user');
    const domain = state.get('domain');
    dispatch({
      type: ANNOUNCEMENT_LOAD + START
    });

    return api.announcement.fetchAnnouncement(dealType, realtyType, filter)
      .then((data) => {
        const list = fromJS(data.items);
        try {
          const cianGtagEvent = new GtagBuilder({})
            .setEvent('newpage')
            .setEventCategory('page')
            .setEventAction('newpage')
            .setEventLabel('open')
            .setUser(user)
            .setPage({
              pageType: 'Listing',
              siteType: 'desktop',
              listingType: filter.viewMode === VIEW_MODE.map ? 'map' : filter.viewMode === VIEW_MODE.paper ? 'table' : 'list',
              dealType: getCianDealType(dealType),
              objectType: getCianObjectType(realtyType),
              sortType: filter.sort ? filter.sort : 'default',
              region: domain.get('regionName').replace(/\.$/, ''),
              offersQty: data._meta.totalCount,
              pageNumber: Number(filter.page) || 1,
              extra: {
                category: getExtraCategory(dealType, realtyType)
              }
            })
            .setProducts(list)
            .getEvent();
          gtagPushEventNewPage(cianGtagEvent);
        } catch (e) {
          console.log(e);
        }
        return dispatch({
          type: ANNOUNCEMENT_LOAD + SUCCESS,
          items: list,
          meta: fromJS(data._meta)
        });
      })
      .catch((err) => dispatch({
        type: ANNOUNCEMENT_LOAD + ERROR,
        payload: err.message
      }));
  };
}

export function fetchAgencies () {
  return (dispatch, getState) => {
    const state = getState();
    const section = state.get('section');
    const dealType = section.get('dealType');
    const realtyType = section.get('realtyType');

    const pure = pureFilter(state.getIn(['search', 'filter']));
    const filter = pure
      .set('regionId', pure.get('regionId', null) || state.getIn(['domain', 'regionId'], 55))
      .set('localityId', pure.get('localityId', null) || state.getIn(['domain', 'localityId'], null))
      .set('token', state.getIn(['user', 'token'], ''))
      .toJS();


    return dispatch(loadAgencies(dealType, realtyType, filter));
  };
}

export function loadAgencies (dealType, realtyType, filter) {
  return dispatch => {
    dispatch({
      type: AGENCIES_LOAD + START
    });

    return api.agency.fetchAgencies(dealType, realtyType, filter)
      .then((data) => dispatch({
        type: AGENCIES_LOAD + SUCCESS,
        items: fromJS(data.items),
      }))
      .catch((err) => dispatch({
        type: AGENCIES_LOAD + ERROR,
        payload: err.message
      }));
  };
}

/**
 * Сбросить фильтр на дефолтный
 * @returns {{type}}
 */
export function resetFilter () {
  return (dispatch, getState) => {
    dispatch({
      type: FILTER_RESET
    });
  };
}

/**
 * Обновить фильтр и перейти на новый адрес
 * @param filter
 * @returns {function(*, *)}
 */
export function updateFilter (filter) {
  return (dispatch, getState) => {
    dispatch({
      type: FILTER_UPDATE,
      payload: fromJS(filter)
    });

    return getState().getIn(['search', 'filter']);
  };
}

/**
 * Вызывает action для установки нового фильтра при смене URL
 * @param location
 * @returns {function(*, *)}
 */
export function setFilterByLocation ({ location }) {
  return (dispatch, getState) => {
    const state = getState();
    const filterFromState = state.getIn(['search', 'filter']);
    const filterFromLocation = queryString.parse(location.search);

    dispatch(updateFilter({...(filterFromState ? filterFromState.toJS() : {}), ...filterFromLocation}));
  };
}

/**
 * Сохраненный поиск
 * @param userId
 * @param data
 * @returns {function(*): (*|undefined|Promise<T | never>)}
 */
export function saveSearchFilter (userId, data) {
  return dispatch => {
    dispatch({
      type: SEARCH_FILTER + START
    });

    return api.user.filtersAdd(userId, data)
      .then((data) => dispatch({
        type: SEARCH_FILTER + SUCCESS
      }))
      .catch((err) => {
        return dispatch({
          type: SEARCH_FILTER + ERROR,
          payload: err.messages
        });
      });
  };
}

/**
 * Подписка на новые
 * @param dealType
 * @param realtyType
 * @param data
 * @returns {function(*): (*|undefined|Promise<T | never>)}
 */
export function saveSubscriptionSearchFilter (dealType, realtyType, data) {
  return dispatch => {
    dispatch({
      type: SUBSCRIPTION + START
    });

    return api.user.subscribeOnFilter(dealType, realtyType, data)
      .then((data) => dispatch({
        type: SUBSCRIPTION + SUCCESS
      }))
      .catch((err) => {
        return dispatch({
          type: SUBSCRIPTION + ERROR,
          payload: err.messages
        });
      });
  };
}

/**
 * Обновить автокомплит
 * @param options
 * @returns {function(*, *)}
 */
export function updateAutocompleteOptions (options) {
  return (dispatch, getState) => {
    dispatch({
      type: AUTOCOMPLETE_UPDATE,
      payload: fromJS(options)
    });

    return getState().getIn(['search', 'selectedOptions']);
  };
}



// WEBPACK FOOTER //
// ./src/app/Search/actions.js